<div class="footer-wrapper">
    <div *ngIf="locale === 'en-us'" class="footer-inner">
        <div class="left-links">
            <!-- <div class="footer-item" (click)="openModal('countries')">
                <span class="country-select">USA - United States</span>
            </div> -->
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/privacy-policy" target="_blank">
                    <span>Privacy</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/terms-of-service/" target="_blank">
                    <span>Terms of Service</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/contact" target="_blank">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>



    <div *ngIf="locale === 'en-au'" class="footer-inner">
        <div class="left-links">
            <!-- <div class="footer-item" (click)="openModal('countries')">
                <span class="country-select">AU - AUSTRALIA</span>
            </div> -->
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-au/about-nvidia/privacy-policy" target="_blank">
                    <span>Privacy</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/terms-of-service/" target="_blank">
                    <span>Terms of Service</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-au/contact" target="_blank">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>


    <div *ngIf="locale === 'en-gb'" class="footer-inner">
        <div class="left-links">
            <!-- <div class="footer-item" (click)="openModal('countries')">
                <span class="country-select">UK - United Kingdom</span>
            </div> -->
            <div class="footer-item">
                <a href="https://www.nvidia.co.uk/about-nvidia/privacy-policy/" target="_blank">
                    <span>Privacy</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/terms-of-service/" target="_blank">
                    <span>Terms of Service</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.co.uk/contact/europe/" target="_blank">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>

    <div *ngIf="locale === 'en-ca'" class="footer-inner">
        <div class="left-links">
            <!-- <div class="footer-item" (click)="openModal('countries')">
                <span class="country-select">CA - CANADA</span>
            </div> -->
            <div class="footer-item">
                <a href="https://www.nvidia.com/about-nvidia/privacy-policy/" target="_blank">
                    <span>Privacy</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/terms-of-service/" target="_blank">
                    <span>Terms of Service</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/contact/europe/" target="_blank">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>

    <div *ngIf="locale === 'pl-pl'" class="footer-inner">
        <div class="left-links">
            <!-- <div class="footer-item" (click)="openModal('countries')">
                <span class="country-select">PL - POLAND</span>
            </div> -->
            <div class="footer-item">
                <a href="https://www.nvidia.pl/about-nvidia/privacy-policy/" target="_blank">
                    <span>Polityka Prywatnosci</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/terms-of-service/" target="_blank">
                    <span>Warunki korzystania z usługi</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.pl/contact/europe/" target="_blank">
                    <span>Kontakt</span>
                </a>
            </div>
        </div>
    </div>

    <div *ngIf="locale === 'fr-ca'" class="footer-inner">
        <div class="left-links">
            <!-- <div class="footer-item" (click)="openModal('countries')">
                <span class="country-select">CA - CANADA</span>
            </div> -->
            <div class="footer-item">
                <a href="https://www.nvidia.fr/about-nvidia/privacy-policy/" target="_blank">
                    <span>Confidentialité</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/terms-of-service/" target="_blank">
                    <span>Conditions d'utilisation</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.fr/contact/europe/" target="_blank">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>


    <div *ngIf="locale === 'fr-fr'" class="footer-inner">
        <div class="left-links">
            <!-- <div class="footer-item" (click)="openModal('countries')">
                <span class="country-select">FR - France</span>
            </div> -->
            <div class="footer-item">
                <a href="https://www.nvidia.fr/about-nvidia/privacy-policy/" target="_blank">
                    <span>Confidentialité</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/terms-of-service/" target="_blank">
                    <span>Conditions d'utilisation</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.fr/contact/europe/" target="_blank">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>
    <div *ngIf="locale === 'de-de'" class="footer-inner">
        <div class="left-links">
            <!-- <div class="footer-item" (click)="openModal('countries')">
                <span class="country-select">DE - Deutschland</span>
            </div> -->
            <div class="footer-item">
                <a href="https://www.nvidia.de/about-nvidia/privacy-policy/" target="_blank">
                    <span>Datenschutz</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/terms-of-service/" target="_blank">
                    <span>Nutzungsbedingungen</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.de/contact/europe/" target="_blank">
                    <span>Kontakt</span>
                </a>
            </div>
        </div>
    </div>

    <div *ngIf="locale === 'ru-ru'" class="footer-inner">
        <div class="left-links">
            <!-- <div class="footer-item" (click)="openModal('countries')">
                <span class="country-select">RU - Россия</span>
            </div> -->
            <div class="footer-item">
                <a href="https://www.nvidia.ru/object/privacy-policy-ru.html" target="_blank">
                    <span>Положение о конфиденциальности</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/terms-of-service/" target="_blank">
                    <span>Условия использования</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="http://www.nvidia.ru/object/contact-information-europe-ru.html" target="_blank">
                    <span>Связаться с нами</span>
                </a>
            </div>
        </div>
    </div>
</div>

<modal id="countries" (click)="closeOverlay($event, par)" (window:keyup)="closeOverlay($event, par)">
    <div class="modal" #par>
        <div class="modal-body">
            <div class="modal-header">
                <div class="modal-header-text">SELECT YOUR LOCATION</div>
                <span class="modal-close" (click)="closeModal('countries');"></span>
            </div>
            <ul class="modal-country-list">
                <li *ngFor="let regionAndCountryList of regionsAndCountriesList" class="modal-region">
                    <span class="modal-country-text">
                        <div class="gf-sub-title">{{regionAndCountryList.region}}</div>
                <li *ngFor="let countryList of regionAndCountryList.countries" class="modal-country">
                    <span class="modal-country-text">
                        <a href="{{countryList.storeUrl}}">
                            <span class="country-line-1">{{countryList.country1}}</span>
                            <span class="country-line-2"><br>{{countryList.country2}}</span>
                        </a>
                    </span>
                </li>
                </span>
                </li>

            </ul>
        </div>
    </div>
    <div #cs id="cs" class="modal-background"></div>
</modal>
